document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("quizForm");

  // Dynamisches Hinzufügen von Personeneingabefeldern
  const personCountInput = document.getElementById("personCount"); // Dieses Feld gibt die Anzahl der Personen an
  personCountInput.addEventListener("change", updatePersonFields);

  function updatePersonFields() {
    const personCount = parseInt(personCountInput.value, 10);
    const personContainer = document.getElementById("personFields");

    // Entferne alte Felder
    personContainer.innerHTML = "";

    // Füge für jede Person die Eingabefelder hinzu
    for (let i = 0; i < personCount; i++) {
      const personDiv = document.createElement("div");
      personDiv.classList.add("person");

      personDiv.innerHTML = `
        <h3>Person ${i + 1}</h3>
        <label for="age_${i}">Alter:</label>
        <input type="number" name="age_${i}" id="age_${i}" placeholder="Alter der Person ${i + 1}" required>

        <label for="gender_${i}">Geschlecht:</label>
        <select name="gender_${i}" id="gender_${i}" required>
          <option value="m">Männlich</option>
          <option value="w">Weiblich</option>
          <option value="d">Divers</option>
        </select>

        <label for="activityLevel_${i}">Aktivitätslevel:</label>
        <select name="activityLevel_${i}" id="activityLevel_${i}" required>
          <option value="low">Niedrig</option>
          <option value="medium">Mittel</option>
          <option value="high">Hoch</option>
        </select>
      `;
      personContainer.appendChild(personDiv);
    }
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const customerId = window.customerId;
    if (!customerId) {
      document.getElementById("quizStatus").innerText = "Du musst eingeloggt sein.";
      return;
    }

    const formData = new FormData(form);
    const quizResults = {
      first_name: formData.get("first_name"),
      last_name: formData.get("last_name"),
      email: formData.get("email"),
      budget: formData.get("budget"),
      diet: formData.get("diet"),
      allergies: formData.getAll("allergies"),
      meal_prep: formData.get("meal_prep") === "true",
      family_members: [],
      chosen_meals: formData.getAll("meals")
    };
    

    // Erfasse die Daten für jede Person
    const personCount = parseInt(personCountInput.value, 10);
    let family_members = []; //Array für die Familienmitglieder
    
    for (let i = 0; i < personCount; i++) {
      const person = {
        age: formData.get(`age_${i}`),
        gender: formData.get(`gender_${i}`),
        activityLevel: formData.get(`activityLevel_${i}`)
      };
      family_members.push(person); //Wir fügen jedes Familienmitglied zum Array hinzu
    }

      quizResults.family_members = family_members; //Speichert die Liste der Familienmitglieder in der Supabase Spalte

     // Supabase URL und Anon Key
    const supabaseUrl = "https://ujtnnxwyvlzmhwuqwgnf.supabase.co";
    const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVqdG5ueHd5dmx6bWh3dXF3Z25mIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY0Mzk4NzIsImV4cCI6MjA2MjAxNTg3Mn0.PKOvLbOiFRxdEPn8YwarG5ShjOxtSrK3qPDILcoOd-c";

     // Verbindung zu Supabase und PATCH-Anfrage
    const response = await fetch(`${supabaseUrl}/rest/v1/users`, {
      method: "POST",
      headers: {
        "apikey": supabaseKey,
        "Authorization": `Bearer ${supabaseKey}`,
        "Content-Type": "application/json",
        "Prefer": "resolution=merge-duplicates",
      },
      body: JSON.stringify([
        {
          id: customerId,
          ...quizResults
        }
        ])
    });

      // Überprüfen, ob die Anfrage erfolgreich war
    if (!response.ok) {
      document.getElementById("quizStatus").innerText = "Fehler beim Speichern.";
    } else {
      // Weiterleitung auf quiz-erfolg Seite
      window.location.href = "https://togetherplates.com/pages/quiz-erfolg";
    }
  });
});
